import React, { useState, useEffect } from 'react';
import { GeoJSON } from 'react-leaflet';

const usdmStyle = [
	{color: "#FFFF00", weight:0, fillColor: "#FFFF00", fillOpacity: 0.8}, //D0
	{color: "#FCD37F", weight:0, fillColor: "#FCD37F", fillOpacity: 0.8}, //D1
	{color: "#FFAA00", weight:0, fillColor: "#FFAA00", fillOpacity: 0.8}, //D2
	{color: "#E60000", weight:0, fillColor: "#E60000", fillOpacity: 0.8}, //D3
	{color: "#730000", weight:0, fillColor: "#730000", fillOpacity: 0.8}  //D4
];

export default function UsdmOverlay(props) {
  const { mode } = props;
  const [ usdm, setUsdm ] = useState(null);

  const prefix = mode === 'dev' ? "vt/" : "https://nedews.nrcc.cornell.edu/";
  const usdmFile = prefix + "./data/usdm.json";

  useEffect(() => {
    fetch(usdmFile)
      .then(res => res.json())
      .then(results => {
        setUsdm(results)
      })
      .catch(err => {
        console.log("USDM Read Error: " + err)
      })
      // eslint-disable-next-line
  }, [])  ;

  return (
    <div>
      {usdm && 
        usdm.map((g, i) => (
          <GeoJSON
            key={i}
            data={g}
            interactive={false}
            style={usdmStyle[g.properties.DM]}
          />
        ))
      }
    </div>
  ) 
}
